<template lang="pug">
  .card
    .card-body
      h4.card-title.text-center.d-flex.justify-content-between
        i.fa.fa-chevron-left(@click.prevent="prev()")
        span Personal Details
        i.fa.fa-chevron-right(@click.prevent="next()")
      hr
      //- p.card-text Lorem ipsum dolor sit amet consectetur adipisicing elit. Recusandae, necessitatibus iste facere sunt! Blanditiis consequuntur odio autem sit delectus doloribus repudiandae laborum, officiis incidunt illo quam ratione, vero iusto praesentium.
      .row
        .col-md-8
          ValidationObserver(ref="Validation" slim)
            ValidationProvider(name="preferred branch" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="branch") Prefered Branch:
                //- select.form-control#branch(name="branch")
                  option(value="") -- Select --
                v-select(:class="{'border-danger': errors.length}" v-model="form.preferredBranch", :options="coops" label="branch_name", :reduce="option => option.id")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="type of membership" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="membership") Type of membership:
                v-select(:class="{'border-danger': errors.length}" v-model="form.membership", :options="memberships" label="name", :reduce="option => option.id")
                  //- template(#option="{ type }")
                    span {{type.name}}
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="last name" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="lastname") Last name:
                input.form-control#lastname(:class="{'border-danger': errors.length}" v-model="form.lastName", type="text" name="lastname" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="first name" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="firstname") First name:
                input.form-control#firstname(:class="{'border-danger': errors.length}" v-model="form.firstName", type="text" name="firstname" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="middle name" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="middlename") Middle name:
                input.form-control#middlename(:class="{'border-danger': errors.length}" v-model="form.middleName", type="text" name="middlename" placeholder="")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="civil status" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="civil_status") Civil Status:
                select.form-control#civil_status(:class="{'border-danger': errors.length}" name="civil_status" v-model="form.civilStatus")
                  option(value="") -- Select --
                  option(value="SINGLE") Single
                  option(value="MARRIED") Married
                  option(value="WIDOWED/WINDOWER") Windowed/Widowed/Windower
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="sex" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="sex") Sex:
                select.form-control#sex(:class="{'border-danger': errors.length}" name="sex" v-model="form.sex")
                  option(value="") -- Select --
                  option(value="MALE") Male
                  option(value="FEMALE") Female
                  option(value="OTHER") Other
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="date of birth" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="date_of_birth") Date of birth:
                //- input.form-control#date_of_birth(:class="{'border-danger': errors.length}" type="text" name="date_of_birth" placeholder="" v-model="form.dateOfBirth")
                date-picker.w-100(v-model="form.dateOfBirth" valueType="format")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="place of birth" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="place_of_birth") Place of Birth:
                //- input.form-control#email_address(type="text" name="email_address" placeholder="")
                textarea.form-control#place_of_birth(:class="{'border-danger': errors.length}" name="place_of_birth" v-model="form.placeOfBirth")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="age" rules="required|numeric" v-slot="{errors}" slim)
              .form-group
                label(for="age") Age:
                input.form-control#age(:class="{'border-danger': errors.length}" type="text" name="age" placeholder="" v-model="form.age")
                //- textarea.form-control#age(name="age")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="e-mail address" rules="required|email" v-slot="{errors}" slim)
              .form-group
                label(for="e-mail_address") E-mail address:
                input.form-control#e-mail_address(:class="{'border-danger': errors.length}" type="text" name="e-mail_address" placeholder="" v-model="form.emailAddress")
                //- textarea.form-control#age(name="age")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="mobile number" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="mobile_number") Mobile number:
                input.form-control#mobile_number(:class="{'border-danger': errors.length}" type="text" name="mobile_number" placeholder="" v-model="form.mobileNumber")
                //- textarea.form-control#age(name="age")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="social number" rules="" v-slot="{errors}" slim)
              .form-group
                label(for="overseas_number") (FOR OVERSEAS) Viber/WhatsApp/Skype Number or FB Messenger Username 
                  i (optional)
                  |:
                input.form-control#overseas_number(:class="{'border-danger': errors.length}" type="text" name="overseas_number" placeholder="" v-model="form.socialContact")
                //- textarea.form-control#age(name="age")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="permanent address" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="permanent_address") Permanent address:
                //- input.form-control#email_address(type="text" name="email_address" placeholder="")
                textarea.form-control#permanent_address(:class="{'border-danger': errors.length}" name="permanent_address" v-model="form.permanentAddress")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            .form-group
              label(for="present_address") Present address:
              //- input.form-control#email_address(type="text" name="email_address" placeholder="")
              .custom-control.custom-checkbox
                input.custom-control-input#same_as_permanent(type="checkbox" v-model="sameAsPermanentAdd")
                label.custom-control-label(for="same_as_permanent") Same as present address?
              ValidationProvider(name="present address" rules="required" v-slot="{errors}" slim)
                textarea.form-control#present_address(:class="{'border-danger': errors.length}" name="present_address" v-model="form.presentAddress")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="owned house" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="owned_house") Do you own a house?
                select.form-control#owned_house(:class="{'border-danger': errors.length}" name="owned_house" v-model="form.ownedHouse")
                  option(value="") -- Select --
                  option(value="OWNED") OWNED
                  option(value="RENTED") RENTED
                  option(value="LIVING_WITH_PARENT") LIVING WITH PARENT
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="years of residence" rules="required|numeric" v-slot="{errors}" slim)
              .form-group
                label(for="years_of_resideny") Years of residency?
                input.form-control#years_of_resideny(:class="{'border-danger': errors.length}" type="text" name="years_of_resideny" placeholder="" v-model="form.yearsOfResidence")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.

            ValidationProvider(name="educational attainment" rules="required" v-slot="{errors}" slim :customMessages="{'required': 'The educational attainment is required.'}")
              .form-group
                label(for="educational_attainment") Educational attainment:
                select.form-control#educational_attainment(:class="{'border-danger': errors.length}" name="educational_attainment" v-model="form.educationalAttainment")
                  option(value="") -- Select --
                  option(value="SCHOOL_LESS_1_YEAR") No schooling completed, or less than 1 year
                  option(value="ELEMENTARY_GRADUATE") Elementary graduate
                  option(value="HIGH_SCHOOL_GRADUATE") High school graduate
                  option(value="COLLEGE_UNDERGRADUATE") College undergraduate
                  option(value="BACHELOR_DEGREE") Bachelor Degree
                  option(value="MATERS_DEGREE") Maters Degree
                  option(value="PROFESSIONAL") Professional/Doctorate Degree
                small.text-danger(v-if="errors.length") {{ errors[0] }}
            ValidationProvider(name="religion" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="religion") Religion:
                input.form-control#religion(:class="{'border-danger': errors.length}" type="text" name="religion" placeholder="" v-model="form.religion")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="nationality" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="nationality") Nationality:
                input.form-control#nationality(:class="{'border-danger': errors.length}" type="text" name="nationality" placeholder="" v-model="form.nationality")
                small.text-danger(v-if="errors.length") {{ errors[0]}}.
            ValidationProvider(name="occupation" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="occupation") Occupation:
                select.form-control#occupation(:class="{'border-danger': errors.length}" name="occupation" v-model="form.occupation")
                  option(value="") -- Select --
                  option(value="GOVERNMENT") Government Employee
                  option(value="PRIVATE") Private Employee
                  option(value="ENTERPRENEUR") Enterpreneur
                  option(value="FARMER") Farmer
                  option(value="FISHERFOLKS") Fisherfolks
                  option(value="PENSIONER") Pensioner
                  option(value="SELF_EMPLOYED") Self employed
                  option(value="STUDENT") Student
                  option(value="NOT_YET_IN_SCHOOL") Not yet in school
                  option(value="OFW") OFW
                  option(value="NONE") None
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="monthly income" rules="required" v-slot="{errors}" slim)
              .form-group
                label Monthly income:
                //- input.form-control#monthly_income(type="text" name="monthly_income" placeholder="")
              .custom-control.custom-radio
                input.custom-control-input#monthly_income1(type="radio" name="monthly_income" value="5K_BELOW" v-model="form.monthlyIncome")
                label.custom-control-label(:class="{'text-danger': errors.length}" for="monthly_income1") 5,000 and below  
              .custom-control.custom-radio
                input.custom-control-input#monthly_income2(type="radio" name="monthly_income" value="5K_10K" v-model="form.monthlyIncome")
                label.custom-control-label(:class="{'text-danger': errors.length}" for="monthly_income2") 5,001 - 10,000
              .custom-control.custom-radio
                input.custom-control-input#monthly_income3(type="radio" name="monthly_income" value="10K_15K" v-model="form.monthlyIncome")
                label.custom-control-label(:class="{'text-danger': errors.length}" for="monthly_income3") 10,001 - 15,000
              .custom-control.custom-radio
                input.custom-control-input#monthly_income4(type="radio" name="monthly_income" value="15K_30K" v-model="form.monthlyIncome")
                label.custom-control-label(:class="{'text-danger': errors.length}" for="monthly_income4") 15,001 - 30,000
              .custom-control.custom-radio
                input.custom-control-input#monthly_income5(type="radio" name="monthly_income" value="30K_ABOVE" v-model="form.monthlyIncome")
                label.custom-control-label(:class="{'text-danger': errors.length}" for="monthly_income5") 30,001 and above
              small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="valid identification" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="valid_id") Valid ID:
                select.form-control#valid_id(:class="{'border-danger': errors.length}" name="valid_id" v-model="form.validID")
                  option(value="") -- Select --
                  option(value="DRIVER_LICENSE") Driver License
                  option(value="UMID") UMID
                  option(value="PAGIBIG") Pagibig
                  option(value="PRC_ID") PRC ID
                  option(value="COMPANY_ID") Company ID
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
            ValidationProvider(name="identification number" rules="required" v-slot="{errors}" slim)
              .form-group
                label(for="id_number") ID Number:
                input.form-control#id_number(:class="{'border-danger': errors.length}" type="text" name="id_number" placeholder="" v-model="form.IDNumber")
                small.text-danger(v-if="errors.length") {{ errors[0] }}.
</template>

<style scoped="">
  .v-select.border-danger >>> .vs__dropdown-toggle {
    border-color: var(--danger);
  }
</style>

<script>
  import { defineComponent, ref, reactive, watch } from '@vue/composition-api'
  
  export default defineComponent({
    name: 'step_2',
    props: {
      coops: {
        type: Array,
        required: true
      },
      memberships: {
        type: Array,
        required: true
      },
      value: {
        type: Object,
        required: true
      }
    },
    emits: ['prev', 'next'],

    setup(props, {emit}) {
      const Validation = ref(null)
      const sameAsPermanentAdd = ref(false)
      const form = reactive(props.value)
      const prev = () => {
        emit('prev')
      }
      const next = () => {
        emit('next')
      }
      const validate = () => {
        emit('input', form)
        return Validation.value.validate()
          .then(success => {
            if(success) {
              return Promise.resolve(success)
            }
            return Promise.reject(success)
          })
      }
      watch(sameAsPermanentAdd, (isSame, previews) => {
        // console.log(isSame, previews)
        if(isSame) {
          form.presentAddress = form.permanentAddress
        } else {
          form.presentAddress = ''
        }
      })
      return {
        sameAsPermanentAdd,
        Validation, validate,
        form,
        prev, next
      }
    }
  })
</script>